module.exports = __webpack_public_path__ + "asset/image-More-dots-d7e248c67ec8f497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/More-dots.svg
// module id = mVCC
// module chunks = 0